var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        size: "lg",
        id: "addToTabModal",
        centered: "",
        title: _vm.$t("pos_guests_modal_title"),
      },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "add-to-tab-form" },
        [
          _c("b-form-select", {
            attrs: { options: _vm.selectableTabs, "select-size": 10 },
            model: {
              value: _vm.selectedTab,
              callback: function ($$v) {
                _vm.selectedTab = $$v
              },
              expression: "selectedTab",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "success" },
              on: {
                click: function ($event) {
                  _vm.addToTab(
                    _vm.tabs.find((tab) => tab.id === _vm.selectedTab)
                  )
                },
              },
            },
            [_vm._v("\n      Add To Open Tab\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }